/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchQueryRequest } from './SearchQueryRequest';
import {
    SearchQueryRequestFromJSON,
    SearchQueryRequestFromJSONTyped,
    SearchQueryRequestToJSON,
    SearchQueryRequestToJSONTyped,
} from './SearchQueryRequest';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ScrollUserRequest
 */
export interface ScrollUserRequest {
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof ScrollUserRequest
     */
    studentLocationIds: Array<ApiUserTasksGetPageParameter>;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof ScrollUserRequest
     */
    studentSeasonIds: Array<ApiUserTasksGetPageParameter>;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof ScrollUserRequest
     */
    locationIds: Array<ApiUserTasksGetPageParameter>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ScrollUserRequest
     */
    roleNames: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ScrollUserRequest
     */
    active: boolean | null;
    /**
     * 
     * @type {SearchQueryRequest}
     * @memberof ScrollUserRequest
     */
    searchQuery: SearchQueryRequest | null;
}

/**
 * Check if a given object implements the ScrollUserRequest interface.
 */
export function instanceOfScrollUserRequest(value: object): value is ScrollUserRequest {
    if (!('studentLocationIds' in value) || value['studentLocationIds'] === undefined) return false;
    if (!('studentSeasonIds' in value) || value['studentSeasonIds'] === undefined) return false;
    if (!('locationIds' in value) || value['locationIds'] === undefined) return false;
    if (!('roleNames' in value) || value['roleNames'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('searchQuery' in value) || value['searchQuery'] === undefined) return false;
    return true;
}

export function ScrollUserRequestFromJSON(json: any): ScrollUserRequest {
    return ScrollUserRequestFromJSONTyped(json, false);
}

export function ScrollUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScrollUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'studentLocationIds': ((json['studentLocationIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
        'studentSeasonIds': ((json['studentSeasonIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
        'locationIds': ((json['locationIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
        'roleNames': json['roleNames'],
        'active': json['active'],
        'searchQuery': SearchQueryRequestFromJSON(json['searchQuery']),
    };
}

export function ScrollUserRequestToJSON(json: any): ScrollUserRequest {
    return ScrollUserRequestToJSONTyped(json, false);
}

export function ScrollUserRequestToJSONTyped(value?: ScrollUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'studentLocationIds': ((value['studentLocationIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
        'studentSeasonIds': ((value['studentSeasonIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
        'locationIds': ((value['locationIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
        'roleNames': value['roleNames'],
        'active': value['active'],
        'searchQuery': SearchQueryRequestToJSON(value['searchQuery']),
    };
}

